import { render, staticRenderFns } from "./CallLogTable.vue?vue&type=template&id=2c743388&"
import script from "./CallLogTable.vue?vue&type=script&lang=js&"
export * from "./CallLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports